import { render, staticRenderFns } from "./LinkMetadata.vue?vue&type=template&id=1e471a24"
import script from "./LinkMetadata.vue?vue&type=script&lang=js"
export * from "./LinkMetadata.vue?vue&type=script&lang=js"
import style0 from "./LinkMetadata.vue?vue&type=style&index=0&id=1e471a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports